import React from 'react';
import Navigation from './components/ui/Navigation';
import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import GallerySection from './components/sections/GallerySection';
import ContactSection from './components/sections/ContactSection';
import KosherSection from './components/sections/KosherSection';
import Footer from './components/ui/Footer';
import WhatsAppFloat from './components/ui/WhatsAppFloat';

function App() {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <GallerySection />
      <ContactSection />
      <KosherSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
